import React, { useCallback } from 'react';
import { ListGroup } from 'react-bootstrap';
import { Tooltip, styled, tooltipClasses } from '@mui/material';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));
const NumberOfIterations = ({ totalIterations, latestIterationExecutions }) => {

  const getStatusData = () => {
    const statusCounts = {};
    latestIterationExecutions && latestIterationExecutions.map(execution => {
      const statusName = execution?.status_details?.name;
      const statusColor = execution?.status_details?.color;
      if (statusCounts[statusName]) {
        statusCounts[statusName].count++;
      } else {
        statusCounts[statusName] = {
          count: 1,
          color: statusColor,
          name: statusName,
        };
      }
    })
    return statusCounts
  }
  const finalStatusCount = useCallback(() => getStatusData(), [latestIterationExecutions]);
  const statusesData = finalStatusCount()

  const renderTooltip = () => (
    <HtmlTooltip
      id="test-case-tooltip"
      title={<ListGroup variant="flush">
        <ListGroup.Item style={{ whiteSpace: 'nowrap' }}><strong>Latest iteration results</strong></ListGroup.Item>
        <ListGroup.Item style={{ whiteSpace: 'nowrap' }}>No of testcases: {statusesData && Object.values(statusesData).reduce((total, item) => total + item.count, 0)}</ListGroup.Item>
        {
          statusesData && Object.keys(statusesData).length > 0 && Object.keys(statusesData).map((status, index) => {
            return (
              statusesData[status].count ?
                <ListGroup.Item key={'status' + index} style={{ color: statusesData[status].color }}>{statusesData[status].name} : {statusesData[status].count || 0}
                </ListGroup.Item> :
                null
            )
          })
        }
      </ListGroup>}>
      <span className='cursor-pointer'>
        {totalIterations}
      </span>
    </HtmlTooltip>
  );

  return (
    <>
      {renderTooltip()}
    </>
  );
};

export default NumberOfIterations;
